module.exports = __webpack_public_path__ + "static/img/2.bf5ee12.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/2/sp/2.png
// module id = Zbc2
// module chunks = 0